import { mapEnumToOptions } from '@abp/ng.core';

export enum TestAttemptEntity {
  Course = 0,
  Document = 1,
}

export const testAttemptEntityOptions = mapEnumToOptions(TestAttemptEntity);
